import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {BaseProtocolFormComponent} from "../base-protocol-form/base-protocol-form.component";
import {DeviceType, MetricGroup} from "../../../../../models/device-type/DeviceType";
import {ProtocolTypeEnum} from "../../../../../enums/registry/ProtocolTypeEnum";
import {DataType} from "../../../../../models/metric/DataType";
import {DxDataGridComponent} from "devextreme-angular";

@Component({
  selector: 'app-s7-group-table',
  templateUrl: './s7-group-table.component.html',
  styleUrls: ['./s7-group-table.component.css']
})
export class S7GroupTableComponent extends BaseProtocolFormComponent {

  @ViewChild('groupDataGrid', {static: false}) dataGrid?: DxDataGridComponent;

  private _isEditMode: boolean;
  private _selectedGroupMetric?: MetricGroup;
  private _selectedGroupMetricRow: number[] = [];
  private _deviceType?: DeviceType;
  private _metricIsBeingEdited: boolean = false;

  @Output() metricIsBeingEditedChange: EventEmitter<boolean> = new EventEmitter();

  get metricIsBeingEdited() {
    return this._metricIsBeingEdited;
  }

  @Input() set metricIsBeingEdited(value) {
    this._metricIsBeingEdited = value;
    this.metricIsBeingEditedChange.emit(this.metricIsBeingEdited);
  }

  @Output() deviceTypeChange: EventEmitter<DeviceType> = new EventEmitter();

  get deviceType(): DeviceType | undefined {
    return this._deviceType;
  }

  @Input() set deviceType(value: DeviceType) {
    this._deviceType = value;
    this.deviceTypeChange.emit(this.deviceType);
  }

  @Output() isEditModeChange: EventEmitter<any> = new EventEmitter();

  get isEditMode(): boolean {
    return this._isEditMode;
  }

  @Input() set isEditMode(value: boolean) {
    this._isEditMode = value;
    this.isEditModeChange.emit(this.isEditMode);
  }

  constructor() {
    super();
    this._isEditMode = false;
  }


  @Output() selectedGroupMetricRowChange: EventEmitter<any> = new EventEmitter();

  get selectedGroupMetricRow(): number[] {
    return this._selectedGroupMetricRow;
  }

  @Input() set selectedGroupMetricRow(value: number[]) {
    this._selectedGroupMetricRow = value;
    this.selectedGroupMetricRowChange.emit(this.selectedGroupMetricRow)
  }

  @Output() selectedGroupMetricChange: EventEmitter<any> = new EventEmitter();

  get selectedGroupMetric(): MetricGroup | undefined {
    return this._selectedGroupMetric;
  }

  @Input() set selectedGroupMetric(value: MetricGroup | undefined) {
    this._selectedGroupMetric = value;
    this.selectedGroupMetricChange.emit(this.selectedGroupMetric)
  }

  async groupEditStart($event: any, editStarted: boolean) {
    if (editStarted && this.blockedByMetricEdit()) {
      $event.cancel = true;
      return;
    }
    if (editStarted) {

      if (!this.groupIsBeingEdited) {
        this.groupIsBeingEdited = true;

        this.groupMetric = $event.data;
        if (!this.groupMetric!.metrics)
          this.groupMetric!.metrics = [];

        this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));

        this.selectedGroupMetricRow = [$event.data.id];

      } else {
        $event.cancel = true;
        const dialogResult = await this.showDiscardEditsDialogWithPromise();
        if (dialogResult) {
          this.groupIsBeingEdited = false;

          $event.component.editRow($event.component.getRowIndexByKey($event.data.id));

          this.groupMetric = $event.data;
          if (!this.groupMetric!.metrics)
            this.groupMetric!.metrics = [];

          this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));

          this.selectedGroupMetricRow = [$event.data.id];
        } else {
          this.selectedGroupMetricRow = [this.selectedGroupMetric!.id!];
        }
      }
    } else {
      this.groupIsBeingEdited = false;
    }
  }

  editGroupAddRowButton($event: any) {
    const toolbarItems = $event.toolbarOptions.items;
    toolbarItems.forEach((item: any) => {
      if (item.name === 'addRowButton') {
        item.options = {
          icon: 'add',
          onClick: () => this.customGroupAddRow($event)
        };
      }
    });
  }

  customGroupAddRow($event: any) {
    if (this.blockedByMetricEdit()) return;
    if (!this.groupIsBeingEdited) {
      $event.component.addRow().done(() => {
        let newRow = $event.component.getVisibleRows()[$event.component.getVisibleRows().length - 1];

        this.groupMetric = newRow.data;
        if (!this.groupMetric!.metrics)
          this.groupMetric!.metrics = [];

        this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));

        this.selectedGroupMetricRow = [newRow.data.id];
        this.groupIsBeingEdited = true;
      });
    } else {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {

          $event.component.addRow().done(() => {
            let newRow = $event.component.getVisibleRows()[$event.component.getVisibleRows().length - 1];

            this.groupMetric = newRow.data;
            if (!this.groupMetric!.metrics)
              this.groupMetric!.metrics = [];

            this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));

            this.selectedGroupMetricRow = [newRow.data.id];
            this.groupIsBeingEdited = true;
          });


        } else {
          this.selectedGroupMetricRow = [this.selectedGroupMetric!.id!];
        }
      });
    }

  }

  duplicateGroup(group: MetricGroup) {
    const groups = this.deviceType!.metricGroups!;
    const index = groups.indexOf(group);
    const clone = this.cloneGroup(group, groups.map(g => g.name));
    groups.splice(index + 1, 0, clone);

    this.groupMetric = clone;
    if (!this.groupMetric!.metrics) this.groupMetric!.metrics = [];
    this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));
    this.reorderDeviceMetrics();
    this.selectedGroupMetricRow = [(clone as any).id];

    this.dataGrid?.instance.refresh();
    this.checkEditDeviceTypeValidation.emit();
  }

  onDuplicateGroupClick = (e: any) => {
    e.event?.stopPropagation();
    if (this.blockedByMetricEdit()) return;
    this.duplicateGroup(e.row.data);
  };

  onGroupDeleted($event: any) {
    this.metricRowStateTracker?.resetScope($event.data.id);
    if (!!this.selectedGroupMetric && this.selectedGroupMetric!.id === $event.data.id) {
      this.groupMetric = undefined;
      this.selectedGroupMetric = undefined;
      this.selectedGroupMetricRow = [];
    }
  }


  getAvailablePollingFunctions(currentDeviceType?: DeviceType) {
    if (!currentDeviceType?.protocolType) {
      return [];
    }
    switch (currentDeviceType.protocolType) {
      case ProtocolTypeEnum.MODBUS_RTU:
        return this.gmService.modbusFunctionValues;
      case ProtocolTypeEnum.MODBUS_TCP:
        return this.gmService.modbusFunctionValues;
      case ProtocolTypeEnum.SIEMENS_S7:
        return this.gmService.s7FunctionValues;
      default:
        return [];
    }
  }


  /**
   * Open drawer when clicking on a tree list row (only if the event is not a click on the arrow to open the children)
   * @param $event
   */
  onGroupMetricRowClick($event: any) {
    if (this.selectedGroupMetric && $event.data.id !== this.selectedGroupMetric.id && this.blockedByMetricEdit())
      return;
    if (!this.selectedGroupMetric) {
      this.groupMetric = $event.data;
      if (!this.groupMetric!.metrics)
        this.groupMetric!.metrics = [];

      this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));
      this.reorderDeviceMetrics();
      this.selectedGroupMetricRow = [$event.data.id];
    } else if ($event.data.id !== this.selectedGroupMetric.id) {
      if (this.groupIsBeingEdited) {
        this.selectedGroupMetricRow = [this.selectedGroupMetric!.id!];
      } else {
        this.groupMetric = $event.data;
        if (!this.groupMetric!.metrics)
          this.groupMetric!.metrics = [];

        this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));
        this.reorderDeviceMetrics();
        this.selectedGroupMetricRow = [$event.data.id];
      }
    }
  }

  reorderDeviceMetrics() {
    this.selectedGroupMetric = JSON.parse(JSON.stringify(this.groupMetric));
    if (!!this.selectedGroupMetric && !!this.selectedGroupMetric.metrics) {
      this.selectedGroupMetric.metrics.sort(
        (a, b) => {
          if (a.id !== undefined && b.id !== undefined)
            return a.id - b.id;
          else
            return -1;
        });
    }
  }


  initMetricGroup($event: any) {
    this.groupMetric = $event.data;
    if (!this.groupMetric!.metrics)
      this.groupMetric!.metrics = [];
    this.reorderDeviceMetrics();
    this.selectedGroupMetricRow = [$event.data.id];
  }

  onCellPreparedMetricGroup(e: any) {
    if (!!e && e.rowType === 'data' && e.column.command === 'edit' && !!e.data) {
      let currentGroup = e.data as MetricGroup;
      if (!!currentGroup.metrics) {
        this.onCellPreparedSwapSaveIcon(e);
      }
    }
  }

  protected override getFullDataType(dataTypeName: string): DataType | undefined {
    return this.gmService.s7DataTypeValues.find(dt => dt.value === dataTypeName);
  }
}
